'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Padding = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  ', '\n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n'], ['\n  ', '\n  ', '\n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n  ', ' \n']);

exports.p = p;
exports.px = px;
exports.py = py;
exports.pt = pt;
exports.pr = pr;
exports.pb = pb;
exports.pl = pl;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _core = require('./core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function p(values) {
  return function (_ref) {
    var theme = _ref.theme;

    return (0, _core._p)(values, theme);
  };
}

function px(values) {
  return function (_ref2) {
    var theme = _ref2.theme;

    return (0, _core._px)(values, theme);
  };
}

function py(values) {
  return function (_ref3) {
    var theme = _ref3.theme;

    return (0, _core._py)(values, theme);
  };
}

function pt(values) {
  return function (_ref4) {
    var theme = _ref4.theme;

    return (0, _core._pt)(values, theme);
  };
}

function pr(values) {
  return function (_ref5) {
    var theme = _ref5.theme;

    return (0, _core._pr)(values, theme);
  };
}

function pb(values) {
  return function (_ref6) {
    var theme = _ref6.theme;

    return (0, _core._pb)(values, theme);
  };
}

function pl(values) {
  return function (_ref7) {
    var theme = _ref7.theme;

    return (0, _core._pl)(values, theme);
  };
}

var Padding = exports.Padding = _styledComponents2.default.div(_templateObject, function (_ref8) {
  var inline = _ref8.inline;
  return inline && 'display: inline-block;';
}, function (_ref9) {
  var all = _ref9.all,
      theme = _ref9.theme;
  return (0, _core._p)(all, theme);
}, function (_ref10) {
  var horizontal = _ref10.horizontal,
      theme = _ref10.theme;
  return (0, _core._px)(horizontal, theme);
}, function (_ref11) {
  var vertical = _ref11.vertical,
      theme = _ref11.theme;
  return (0, _core._py)(vertical, theme);
}, function (_ref12) {
  var top = _ref12.top,
      theme = _ref12.theme;
  return (0, _core._pt)(top, theme);
}, function (_ref13) {
  var right = _ref13.right,
      theme = _ref13.theme;
  return (0, _core._pr)(right, theme);
}, function (_ref14) {
  var bottom = _ref14.bottom,
      theme = _ref14.theme;
  return (0, _core._pb)(bottom, theme);
}, function (_ref15) {
  var left = _ref15.left,
      theme = _ref15.theme;
  return (0, _core._pl)(left, theme);
});

exports.default = Padding;


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-spacing/dist/cjs/Padding.js
// module id = 709
// module chunks = 168707334958949